import {useAuthStore} from "../store/auth.store";
import {useEffect, useState} from "react";
import {useDeal} from "../hook/partner/deal.partner.hook";
import {NavLink, useParams} from "react-router";
import {PartnerApi} from "../api/partner.api";
import {useBreadcrumbsStore} from "../store/breadcrumbs.store";
import {useDealsStore} from "../store/deals.store";
import CommentNewModal from "../components/modals/comment/CommentNewModal";
import Comments from "../components/Comments/Comments";
import DealNewModal from "../components/modals/deal/DealNewModal";
import DealChangeStateModal from "../components/modals/deal/DealChangeStateModal";
import { useTranslation } from "../hooks/useTranslation";

function Deal() {
    const { t } = useTranslation();
    const {id} = useParams();
    const [reload, setReload] = useState(0);
    const [page, setPage] = useState('specification');
    const [activeVariation, setActiveVariation] = useState(0);
    const dealMutation = useDeal();

    const token = useAuthStore((state) => state.token);
    const deal = useDealsStore((state) => state.deal);

    const [errorAdd, setErrorAdd] = useState(null);
    const [descriptionNew, setDescriptionNew] = useState("");

    const [showModalChangeState, setShowModalChangeState] = useState(false);

    const [products, setProducts] = useState(null);
    const [selectedProductAdd, setSelectedProductAdd] = useState(null);
    const [errorAddProduct, setErrorAddProduct] = useState(null);
    const [searchProduct, setSearchProduct] = useState("");


    const setBreadcrumbs = useBreadcrumbsStore((state) => state.setBreadcrumbs);
    const setPagename = useBreadcrumbsStore((state) => state.setPagename);
    useEffect(() => {
        setPagename(deal ? ("#" + deal.deal_id + " - " +deal.project_name) : "");
        setBreadcrumbs([{
            name: t("deals.registration") + " Logmanageru", link: "/dealy",
        }]);
    }, [deal, id]);



    useEffect(() => {
        if (token) {
            dealMutation.mutate({token, id})
        }
    }, [token, id, reload]);

    function number_format(number, decimals, dec_point, thousands_sep) {
        // Strip all characters but numerical ones.
        number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
        var n = !isFinite(+number) ? 0 : +number, prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
            sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
            dec = (typeof dec_point === 'undefined') ? '.' : dec_point, s = '', toFixedFix = function (n, prec) {
                var k = Math.pow(10, prec);
                return '' + Math.round(n * k) / k;
            };
        // Fix for IE parseFloat(0.55).toFixed(0) = 0;
        s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
        if (s[0].length > 3) {
            s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
        }
        if ((s[1] || '').length < prec) {
            s[1] = s[1] || '';
            s[1] += new Array(prec - s[1].length + 1).join('0');
        }
        return s.join(dec);
    }


    useEffect(() => {
        if (token && searchProduct) {
            setErrorAddProduct(null);
            PartnerApi.productSearch({token, search: searchProduct}).then((result) => {
                if ("error" in result) {
                    setErrorAddProduct(result.error);
                    setProducts([]);
                    return;
                }
                setProducts(result);
            })
        }
    }, [token, searchProduct]);

    if (!deal) {
        return (<></>);
    }

    const isWritable = () => {
        if (deal.access_rights_of_current_user == "writeAndOrder" || deal.access_rights_of_current_user == "write") {
            return true;
        }

        return false;
    }

    return (<>
        <div className="d-flex justify-content-between py-4">
            <h1>
                {"#" + deal.deal_id + " - " +deal.project_name}
            </h1>
        </div>
        <div className="card ">

            <DealChangeStateModal
                show={showModalChangeState}
                deal={deal}
                callback={()=>setReload(reload+1)}
                handleClose={() => setShowModalChangeState(false)}
            />

            <div className="card-body">
                <div className="row">
                    <div className="col-md-6">
                        <table className="table table-striped table-bordered">
                            <tbody>
                            <tr>
                                <td>{deal.vendor.name}</td>
                                <td className="text-end">
                                    <span className={"badge badge-" + deal.deal_state.state_style}>
                                        {deal.deal_state.state_name}
                                    </span>
                                    {deal.deal_state.state_can_change === 1 && parseInt(deal.deal_state.state_id) === 0 ? (
                                        <div className="mt-2">
                                            <button
                                                className="btn btn-sm btn-primary"
                                                onClick={() =>
                                                    setShowModalChangeState(true)
                                                }
                                            >
                                                {t("deals.stateSelection")}
                                            </button>
                                        </div>
                                    ) : null}
                                </td>
                            </tr>
                            <tr>
                                <td>{t("deals.registrationDate")}</td>
                                <td className="text-end">{deal.registration_date && deal.registration_date != '0000-00-00' ? new Date(deal.registration_date).toLocaleDateString() : '-'}</td>
                            </tr>
                            <tr>
                                <td>{t("deals.expectedCloseDate")}</td>
                                <td className="text-end">{deal.close_date && deal.close_date != '0000-00-00' ? new Date(deal.close_date).toLocaleDateString() : '-'}</td>
                            </tr>
                            <tr>
                                <td>{t("deals.expirationDate")}</td>
                                <td className="text-end">{deal.expiration_date && deal.expiration_date != '0000-00-00' ? new Date(deal.expiration_date).toLocaleDateString() : '-'}</td>
                            </tr>
                            {/*<tr>
                                <td>Datum realizace</td>
                                <td className="text-end">{deal.realization_date && deal.realization_date != '0000-00-00' ? new Date(deal.realization_date).toLocaleDateString() : '-'}</td>
                            </tr>*/}

                            <tr>
                                <td>{t("deals.offer")}</td>
                                <td className="text-end">{deal.opportunity && deal.opportunity.length > 0 && deal.opportunity[0].opportunity_id ? (
                                    <a href={"/prilezitost/" + deal.opportunity[0].opportunity_id}>
                                        {t("deals.here")}
                                    </a>
                                ) : '-'}</td>
                            </tr>

                            </tbody>
                        </table>

                        <h2>{t("deals.partnerContact")}</h2>
                        <table className="table table-striped table-bordered">
                            <tbody>
                            <tr>
                                <td>
                                    {deal.sales_person.first_name} {deal.sales_person.last_name}
                                </td>
                                <td className="text-end">
                                    {deal.sales_person.email}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {deal.sales_person.position}
                                </td>
                                <td className="text-end">
                                    {deal.sales_person.phone}
                                </td>
                            </tr>
                            </tbody>
                        </table>

                        <ul className="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold mb-5 mt-5">
                            <li className="nav-item">
                        <span className={"cursor-pointer nav-link " + (page == 'specification' && "active")}
                              onClick={() => setPage("specification")}
                              aria-current="page">{t("deals.deviceSpec")}</span>
                            </li>
                            <li className="nav-item">
                        <span className={"cursor-pointer nav-link " + (page == 'description' && "active")}
                              onClick={() => setPage("description")}
                              aria-current="page">{t("deals.additionalInfo")}</span>
                            </li>
                        </ul>

                        {page === 'specification' && (
                            deal.specification
                        )}

                        {page === 'description' && (
                            deal.description
                        )}
                    </div>
                    <div className="col-md-6">
                        <h2>{t("opportunities.endCustomer")}</h2>
                        <table className="table table-striped table-bordered">
                            <tbody>
                            <tr>
                                <td colSpan={2}>
                                    {deal.end_customer.name}
                                </td>
                            </tr>
                            <tr>
                                <td>{deal.end_customer.ic}</td>
                                <td className="text-center">{deal.end_customer.dic}</td>
                            </tr>
                            <tr>
                                <td colSpan={2}>
                                    {deal.end_customer.street}
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={2}>
                                    {deal.end_customer.zip}  {deal.end_customer.city}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <h2>{t("deals.customerContact")}</h2>
                        <table className="table table-striped table-bordered">
                            <tbody>
                            <tr>
                                <td>
                                    {deal.end_customer.person.first_name} {deal.end_customer.person.last_name}
                                </td>
                                <td className="text-center">
                                    {deal.end_customer.person.email}
                                </td>
                            </tr>
                            <tr>
                                <td>{deal.end_customer.person.position}</td>
                                <td className="text-center">
                                    {deal.end_customer.person.phone}
                                </td>
                            </tr>
                            </tbody>
                        </table>


                        <h3>{t("deals.updateRegistration")}</h3>

                        <Comments  objectId={deal.deal_id} objectType={"deal"} callback={()=>setReload(reload+1)}
                                   comments={deal.comments}/>
                        <p className={"mt-2"}>{t("deals.noteExtendsRegistration")}</p>
                    </div>

                </div>
            </div>
        </div>

    </>);
}

export default Deal;
